// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"605":"29160c47","1198":"ebdd8882","7886":"b975c426","8230":"a6537c98"}[chunkId] + ".chunk.css";
};